
<template>
  <section class="pt-reviews">
    <div class="container">

      <div class="pt-header">
        <div class="pt-heading">
          <span class="pt-eyebrow">VOTRE SATISFACTION</span>
          <h2>Ils nous font <span>confiance</span></h2>
          <p>
            Votre avis compte pour nous et nous aide
            à améliorer l'expérience ProduPneu.
          </p>
        </div>

        <div v-if="!demoMode && reviews.length" class="pt-rating">
          <div class="pt-rating-line">
            <strong>{{ averageRating }}/5</strong>
            <span class="pt-stars">★★★★★</span>
          </div>
          <small>Basé sur {{ reviews.length }} avis</small>
        </div>
      </div>

      <!-- REAL REVIEWS WHEN AVAILABLE -->
      <div v-if="!demoMode && reviews.length" class="pt-grid">
        <article
          v-for="review in reviews"
          :key="review.id"
          class="pt-card"
        >
          <div class="pt-customer">
            <div class="pt-avatar">
              {{ initial(review.name) }}
            </div>

            <div class="pt-customer-info">
              <strong>{{ review.name }}</strong>
              <div class="pt-stars" :aria-label="review.rating + ' sur 5'">
                {{ stars(review.rating) }}
              </div>
              <small>{{ review.date }}</small>
            </div>
          </div>

          <p>{{ review.text }}</p>

          <div v-if="review.verified" class="pt-verified">
            <svg viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="9"/>
              <path d="m7 12 3 3 7-7"/>
            </svg>
            Avis vérifié
          </div>
        </article>
      </div>

      <!-- DESIGN PLACEHOLDER -->
      <div v-else class="pt-empty">
        <div class="pt-empty-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M4 4h16v13H8l-4 4V4z"/>
            <path d="m9 10 2 2 4-4"/>
          </svg>
        </div>

        <div class="pt-empty-copy">
          <h3>Votre expérience nous intéresse</h3>
          <p>
            Une section dédiée aux avis clients sera bientôt
            disponible ici. Pour toute question sur nos services,
            notre équipe reste à votre écoute.
          </p>
        </div>

        <router-link to="/contact" class="pt-button">
          Nous contacter
          <span>→</span>
        </router-link>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "Testimonials",

  data() {
    return {
      demoMode: true,

      // Insert genuine reviews only, with permission
      // to display customer names and feedback.
      reviews: [],
    };
  },

  computed: {
    averageRating() {
      if (!this.reviews.length) return "0,0";

      const sum = this.reviews.reduce(
        (total, review) => total + Number(review.rating),
        0
      );

      return (sum / this.reviews.length)
        .toFixed(1)
        .replace(".", ",");
    },
  },

  methods: {
    initial(name) {
      return String(name || "?").charAt(0).toUpperCase();
    },

    stars(rating) {
      const n = Math.max(0, Math.min(5, Math.round(Number(rating))));
      return "★".repeat(n) + "☆".repeat(5 - n);
    },
  },
};
</script>

<style scoped>
.pt-reviews {
  background: #f4f7f9;
  padding: 55px 0 70px;
  font-family: "Poppins", sans-serif;
}

.pt-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 25px;
  margin-bottom: 24px;
}

.pt-eyebrow {
  display: block;
  color: #ff7900;
  letter-spacing: 2px;
  font-size: 10px;
  font-weight: 800;
  margin-bottom: 9px;
}

.pt-heading h2 {
  font-size: clamp(25px, 2.6vw, 34px);
  font-weight: 900;
  line-height: 1.3;
  letter-spacing: -.7px;
  color: #1c2329;
  margin: 0 0 8px;
}

.pt-heading h2 span {
  color: #ff7900;
}

.pt-heading p {
  font-size: 12px;
  color: #7b858e;
  line-height: 1.8;
  margin: 0;
}

.pt-rating {
  text-align: right;
  white-space: nowrap;
}

.pt-rating-line {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pt-rating-line strong {
  color: #192127;
  font-size: 24px;
  font-weight: 900;
}

.pt-stars {
  color: #ff9000;
  font-size: 17px;
  letter-spacing: 1px;
}

.pt-rating small {
  color: #8b939b;
  font-size: 10px;
}

.pt-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 15px;
}

.pt-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e6ebee;
  border-radius: 13px;
  padding: 22px;
  box-shadow: 0 4px 16px rgba(20,28,34,.035);
}

.pt-customer {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.pt-avatar {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background: #fff1e4;
  color: #ed7600;
  font-size: 19px;
  font-weight: 900;
}

.pt-customer-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pt-customer-info strong {
  font-size: 12px;
  color: #22282e;
}

.pt-customer-info .pt-stars {
  font-size: 14px;
}

.pt-customer-info small {
  color: #999fa6;
  font-size: 10px;
}

.pt-card > p {
  font-size: 12px;
  line-height: 1.8;
  color: #5f6870;
  margin: 0 0 18px;
}

.pt-verified {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #20804b;
  margin-top: auto;
  font-size: 10px;
  font-weight: 700;
}

.pt-verified svg {
  width: 14px;
  height: 14px;
  stroke: currentColor;
  stroke-width: 2;
}

.pt-empty {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 30px 32px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e6ebee;
  box-shadow: 0 5px 22px rgba(20,28,34,.04);
}

.pt-empty-icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 70px;
  height: 70px;
  background: #fff1e6;
  border-radius: 15px;
  color: #ff7900;
}

.pt-empty-icon svg {
  width: 38px;
  height: 38px;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.pt-empty-copy {
  flex: 1;
}

.pt-empty-copy h3 {
  color: #20272d;
  font-size: 17px;
  font-weight: 850;
  margin: 0 0 8px;
}

.pt-empty-copy p {
  color: #78828b;
  line-height: 1.8;
  font-size: 12px;
  margin: 0;
}

.pt-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 13px 18px;
  border: 1px solid #ff7900;
  border-radius: 8px;
  color: #ff7900;
  text-decoration: none !important;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 800;
}

.pt-button:hover {
  color: #fff;
  background: #ff7900;
}

@media (max-width: 991px) {
  .pt-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pt-empty {
    flex-wrap: wrap;
  }
}

@media (max-width: 767px) {
  .pt-reviews {
    padding: 45px 0 55px;
  }

  .pt-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .pt-rating {
    text-align: left;
  }

  .pt-grid {
    grid-template-columns: 1fr;
  }

  .pt-empty {
    padding: 23px;
    gap: 18px;
  }
}
</style>
